import { getVariantPagePath } from "./helpers"

// Generates the correct upsell page url with freely-defined page name suffix
// to avoid fully hardcoded values in JS which should match with pipelineConfig pagePaths.
// You need to pass the page name suffix which you know is defined in the pagePaths.
// Example:
// generateUpsellPageUrl({ upsellOfferType: offer.type, nameSuffix: "any" })
// Return "/en-gb/default/upsell-premium-any"
const generateUpsellPageUrl = ({ upsellOfferType, nameSuffix }) => {
  const namePrefix = "upsell"
  const normalizedTypeName = upsellOfferType.toLowerCase().replace(/_/g, '-')
  const pagePath = `${namePrefix}-${normalizedTypeName}-${nameSuffix || 'offer'}`
  const variantPath = getVariantPagePath({ pagePath, pipelineConfig })

  return `${window.location.origin}${pipelineConfig.pathPrefix}${variantPath || ''}`
}

const getUpsellOffers = (offers) => {
  return offers
    .filter((offer) => offer.type && offer.type.toLowerCase() !== "basic")
    .sort((a, b) => a.customData.sequence - b.customData.sequence)
}

export {
  generateUpsellPageUrl,
  getUpsellOffers,
}
